import { useDispatch } from "react-redux";
import { setactiveItem } from "store/cards";

const CraftBlockItemTooltip = ({ item }) => {
  const dispatch = useDispatch();

  const setActiveItem = (e) => {
    e.stopPropagation();
    dispatch(setactiveItem(item));
  };

  return (
    <button
      className="craft-block__step-tooltip"
      onClick={setActiveItem}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.16667 9.16667H10V13.3333M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z"
          stroke="#ffffff99"
          strokeWidth="1.6"
          strokeLinecap="square"
        ></path>
        <rect
          x="9.33331"
          y="6"
          width="1.33333"
          height="1.33333"
          fill="#ffffff99"
          stroke="#ffffff99"
          strokeWidth="0.5"
        ></rect>
      </svg>
    </button>
  );
};

export default CraftBlockItemTooltip;
